export default __webpack_public_path__ + "b56f708fd3c86b55dbe58078760db796.webp";